<template>
  <div class="page-container">
    <QrDetail variant="modal" />
    <div class="pp_item">
      <div class="pp-main">
        <div class="pp-img">
          <img :src="data.rectangle" v-bind:key="data.rectangle" alt="">
        </div>
        <div class="title">
          <span>{{data.special_name}}</span>
          <div class="time">{{time | formatTimer}}</div>
        </div>
        <p class="pp-desc">
          <span class="label">拍品数量：</span>
          <span class="tb">{{data.product_count}}</span>
        </p>
        <p class="pp-desc">
          <span class="label">竞拍时间：</span>
          <span class="tb">{{data.start_date + '-' +data.end_date }}</span>
        </p>
      </div>
    </div>

    <div class="pp-ft">
      <Panel :plain="false" :title="'拍品列表'">
        <div class="act-list">
          <el-row>
            <el-col class="act-box" :span="8" v-for="(item,index) in list" :key="index">
              <router-link :to="{path:'/auction/item',query:{id:item.id}}" class="act-item">
                <div class="imgbox"><img :src="item.photo" alt=""></div>
                <div class="act-info">
                  <p class="act-title">{{item.product_name}}</p>
                  <p class="act-desc">结束时间：{{item.end_date}}</p>
                  <!-- <p class="act-desc">最高价<span class="price">￥{{item.maxprice}}</span></p> -->
                  <el-button class="xt-btn" round>查看详情</el-button>
                  <p class="act-status"><span>{{item.price_count}}人出价</span><span>{{item.look_count}}人围观</span></p>
                </div>
              </router-link>
            </el-col>
          </el-row>
          <el-link class="btn-more" :underline="false" disabled v-if="isend">没有更多了</el-link>
          <el-link class="btn-more" :underline="false" @click="specialDetail" v-if="!isend">加载更多</el-link>
        </div>

      </Panel>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.pp_item {
  margin-top: 20px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 1px 7px 0px rgba(11, 3, 6, 0.3);
  padding: 0 15px 15px;
  .pp-main {
    img {
      width: 100%;
    }
  }
  .title {
    font-size: 22px;
    line-height: 30px;
    margin-top: 10px;
    .time {
      float: right;
      color: #bc230c;
      font-weight: bold;
    }
  }
  .pp-desc {
    .tb {
      color: #5a5a5a;
    }
  }
}
.pp-ft {
  margin-top: 20px;
}
.act-list {
  margin-left: -15px;
  margin-right: -15px;

  .act-box {
    margin-top: 20px;
    padding: 0 15px;
  }
  .act-item {
    border-radius: 8px;
    overflow: hidden;
    display: block;
    text-decoration: none;
    background-color: #fff;
    &:hover {
      box-shadow: 0px 1px 7px 0px rgba(11, 3, 6, 0.3);
    }
    .imgbox {
      padding-top: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 200px auto;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        position: absolute;
        top: 50%;
        left: 50%;
      }
    }
    .act-info {
      padding: 20px 15px;
      text-align: center;
      .act-title {
        font-size: 20px;
        font-weight: bold;
      }
      .act-desc {
        font-size: 14px;
        color: #999;
      }
      .price {
        margin-left: 10px;
        font-size: 20px;
        color: #bc230c;
      }
      .act-status {
        color: #474747;
        > span:nth-of-type(2) {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
<script>
import Panel from '../../components/panel.vue'
import QrDetail from '../../components/qrdetail.vue'
import {
  AuctionAPI
} from "../../model/auction.js";
let auctionAPI = new AuctionAPI();
export default {
  name: 'auction',
  data() {
    return {
      id: this.$route.query.id,
      pageIndex: 1,
      share: false,
      pageSize: 30,
      isend: false,
      data: {},
      product_count: '',
      nowtime: '',
      list: [],
      time: '',
      timer: 0
    }
  },
  filters: {
    formatTimer(time) {
      function normalize(x) {
        return x < 10 ? '0' + x : x;
      }
      if (time > 0) {
        var h = normalize(time / 3600 | 0);
        var m = normalize(time / 60 % 60 | 0);
        var s = normalize(time % 60);
        return '距结束' + (h + ':' + m + ':' + s);
      } else {
        return '已结束';
      }
    }
  },
  components: {
    Panel,
    QrDetail
  },
  methods: {
    specialDetail() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        auctionAPI.getSpecialDetailById({
          SpecialId: _this.id,
          PageIndex: _this.pageIndex,
          PageSize: _this.pageSize,
        }).then((res) => {
          _this.data = res.data.special;
          _this.nowtime = res.NowTime
          let list = res.data.productlist;
          if (list.length < _this.pageSize || list.length == 0) {
            _this.isend = true;
          }
          _this.list = list.length > 0 ? _this.list.concat(list) : _this.list;
          _this.pageIndex++
          let moment = require("moment");
          let nowtime = moment(_this.nowtime, 'YYYY-MM-DD HH:mm:ss').format('X');
          let overTime = moment(_this.data.end_date, 'YYYY-MM-DD HH:mm:ss').format('X');
          let fromTime = overTime - nowtime;
          _this.time = fromTime;
          //开始执行倒计时
          _this.setTimeout()
          resolve();
        }, () => {
          reject();
        })
      })
    },
    setTimeout() {
      let _this = this;
      // let timer
      _this.timer && clearInterval(_this.timer);
      _this.timer = setInterval(function () {
        let list = _this.time;
        list > 0 ? list-- : '结束';
        _this.time = list;
      }, 1000);
    },
  },
  created() {
    this.specialDetail()
  },
  destroyed(){
    clearInterval(this.timer);
  }
}
</script>